import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './Viewer.module.css';
import { Button, Input, FormGroup, Label } from 'reactstrap';
import Dialog from './Dialog';
import { Link } from 'react-router-dom';
import axios from 'axios';
import gear from '../images/gear.svg';
import preview from '../images/preview.svg';
import Header from './Header';
import Footer from './Footer';
import Notification from './Notification';
import BackButton from './BackButton';
import Area from './Area';
import Spinner from './Spinner';
import defaultConfig from './defaultConfig.json';
import { Helmet } from 'react-helmet';
import JsonEditor from "../helpers/JsonEditor"



class Viewer extends Component {
  state = {
    dialogVisible: false,
    notification: {},
    loading: true,
     showJSONEditor: false   
  };

  onJsonEditClick=()=>
  {
    this.setState({showJSONEditor:true});

  }


  componentDidMount() {
    let projectPath = this.props.match.params.projectPath;
    let viewerPath = this.props.match.params.viewerPath;

    let viewer = this.props.project.viewers.find(viewer => viewer.path === viewerPath);
    if (viewer && viewer.loaded) {
      return this.setState({
        viewer,
        loading: false
      });
    }

    let url = `/api/projects/${projectPath}/viewers/${viewerPath}`;
    if (window.CONNECTED_APPS_STATIC) {
      url = './config.json';
    }

    axios({
      method: 'get',
      url,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('kvk-vb-token')}`
      }
    })
      .then(({ data }) => {
       

        this.setState({
          viewer: data,
          loading: false
        });
        this.props.dispatch({
          type: 'FETCH_VIEWER_SUCCESS',
          data
        });
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.props.history.push('/login', `projects/${projectPath}/${viewerPath}`);
        } else if (error.response.status === 404) {
          let viewer = defaultConfig;
          viewer.path = viewerPath;
          viewer.new = true;
          this.setState({
            viewer,
            loading: false
          });
        } else {
          console.log(error.response.message);
        }
      });
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  onChange = config => {
    let viewer = {
      ...this.state.viewer,
      mainArea: config
    };
    this.setState({ viewer });
  };

  save = () => {
    let viewer = this.state.viewer;
    delete viewer.project;

    let projectPath = this.props.match.params.projectPath;
    let viewerPath = this.props.match.params.viewerPath;

    let url = `/api/projects/${projectPath}/viewers` + (viewer.new ? '' : `/${viewerPath}`);
    axios({
      method: viewer.new ? 'post' : 'put',
      url,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('kvk-vb-token')}`
      },
      data: viewer
    })
      .then(({ data }) => {
        this.setState({ notification: { text: 'saved', type: 'success' } });
        this.timer = setTimeout(() => this.setState({ notification: {} }), 3000);

        let viewer = {
          ...data,
          new: false
        };
        this.setState({ viewer });
        this.props.dispatch({
          type: 'SAVE_VIEWER_SUCCESS',
          data
        });
        let s = data;
        delete s.id;
        delete s.path;
        delete s.project;
        delete s.user;
        delete s.createdAt;
       // console.log(JSON.stringify(s));
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.props.history.push('/login', `projects/${projectPath}/${viewerPath}`);
        } else {
          this.setState({ notification: { text: 'not saved: ' + error.response.data, type: 'failure' } });
          this.timer = setTimeout(() => this.setState({ notification: {} }), 3000);
        }
      });
  };

  onDialogOkClick = () => {
    this.setState({ dialogVisible: false });
    this.save();
  };


  onHeaderClick = e => {
    if (this.props.match.params.mode === 'edit') {
      this.setState({ dialogVisible: true });
    }
  };

  jsonOKClick=() =>{
    console.log("jsonOK click");
    this.setState({ showJSONEditor: false });
  }

  render() {
    if (this.state.loading) return <Spinner />;
    let { isAuthenticated, role } = this.props.me;
    
    let viewer = this.state.viewer;
    if (!viewer) return null;

    let mode = this.props.match.params.mode;
    let notification = this.state.notification;
    let projectPath = this.props.match.params.projectPath;
    let viewerPath = this.props.match.params.viewerPath;

    let css = viewer.css;
    if (css) {
      try {
        css = JSON.parse(css);
      } catch (error) {
        css = {}
      }
    } else {
      css = {}
    }
    /*if (this.state.showJSONEditor)
    {
              return (<JsonEditor></JsonEditor>)
    }
    else
    */
    {
    return (

      <div className={styles.wrapper} style={css}>
        <Helmet>
          <title>{viewer.title}</title>
          {viewer.project && (
            <link
              rel="icon"
              type="image/png"
              href={`${window.CONNECTED_APPS_STATIC ? '.' : ''}/favicon-${viewer.project.path}.png`}
              sizes="16x16"
            />
          )}
        </Helmet>
        <Notification messageType={notification.type} text={notification.text} />
        {!window.CONNECTED_APPS_STATIC && <BackButton to={`/projects/${projectPath}`} />}
        {isAuthenticated && role !== 'viewer' && (
          <div className={styles.editButton}>
            {mode === 'edit' ? (
              <Link to={`/projects/${projectPath}/${viewerPath}`} style={{ textDecoration: 'none', color: 'white' }}>
                <img src={preview} alt="preview" style={{ width: '22px' }} />
              </Link>
            ) : (
              <Link to={`/projects/${projectPath}/${viewerPath}/edit`} style={{ textDecoration: 'none' }}>
                <img src={gear} alt="gear" style={{ width: '19px', opacity: '0.5' }} />
              </Link>
            )}
          </div>
        )}

        <Header
          title={viewer.title}
          pageWidth={viewer.pageWidth}
          noLoginButton
          logoURL={viewer.logoURL}
          onClick={mode === 'edit' ? this.onHeaderClick : null}
        />
        {this.state.dialogVisible && (
          <Dialog>
            <FormGroup>
              <Label>Titel</Label>
              <Input
                className="dark-form-control"
                value={viewer.title || ''}
                type="text"
                onChange={e => this.setState({ viewer: { ...viewer, title: e.target.value } })}
              />
            </FormGroup>
            <FormGroup>
              <Label>GraphDB Repo URL</Label>
              <Input
                className="dark-form-control"
                value={viewer.repoURL || ''}
                type="text"
                onChange={e => this.setState({ viewer: { ...viewer, repoURL: e.target.value } })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Logo URL</Label>
              <Input
                className="dark-form-control"
                value={viewer.logoURL || ''}
                type="text"
                onChange={e => this.setState({ viewer: { ...viewer, logoURL: e.target.value } })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Global CSS in JSON formaat, bijvoorbeeld: {'{"color":"red"}'}</Label>
              <Input
                className="dark-form-control"
                value={viewer.css || ''}
                type="text"
                onChange={e => this.setState({ viewer: { ...viewer, css: e.target.value } })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Pagina breedte</Label>
              <Input
                className="dark-form-control"
                value={viewer.pageWidth || '1120px'}
                type="text"
                onChange={e => this.setState({ viewer: { ...viewer, pageWidth: e.target.value } })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Config in JSON formaat</Label>
              <Input
                className="dark-form-control"
                value={JSON.stringify(viewer)|| ''}
                type="text"
                onChange={e =>  {
                   let config=JSON.parse(e.target.value) 
                  
                   if (config!=null)
                   {
                    var old=this.state.viewer
                    config.id=old.id;config.user=old.user;config.path=old.path
                    this.setState({ viewer:  config  })
                  } 
                  }
                }
                   
              />
                <Button color="primary" style={{ minWidth: '120px', marginTop: '12px' }} onClick={this.onJsonEditClick}>
                edit
              </Button>

            </FormGroup>
            <FormGroup>
              <Label>
                <Input
                  checked={viewer.public}
                  style={{ marginLeft: '0', position: 'relative' }}
                  type="checkbox"
                  onChange={e => this.setState({ viewer: { ...viewer, public: e.target.checked } })}
                />{' '}
                publiek
              </Label>
            </FormGroup>
            <div style={{ textAlign: 'center' }}>
              <Button color="primary" style={{ minWidth: '120px', marginTop: '12px' }} onClick={this.onDialogOkClick}>
                OK
              </Button>
            </div>
          </Dialog>
        )}
        {this.state.showJSONEditor && (
        <JsonEditor test='hans' config={this.state.viewer} handleChange={e =>  {
          let config=e; 
         
          if (config!=null)
          {
           var old=this.state.viewer
           config.id=old.id;config.user=old.user;config.path=old.path
           this.setState({ viewer:  config  })
         } 
         }} okClick={this.jsonOKClick}></JsonEditor>
        )}
        <div className={styles.mainContainer}>
          <div className={styles.main} style={{maxWidth: viewer.pageWidth }}>
            <div className={styles.areaContainer}>
              <Area
                config={viewer.mainArea}
                onChange={this.onChange}
                mode={mode}
                repoURL={viewer.repoURL}
                save={this.save}
              />
            </div>
          </div>
          <Footer config={viewer.footer}/>
        </div>
      </div>
    );
  }
}
}

const mapStateToProps = state => ({
  project: state.project,
  me: state.me
});

export default connect(mapStateToProps)(Viewer);
